export default __webpack_public_path__ + "static/4-a58a72b8379bb0360882a599e6ffcd53.jpeg";